import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

const languages = [
  { code: 'hy', label: 'Հայերեն', flag: '🇦🇲' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'en', label: 'English', flag: '🇬🇧' }
];
 

  const currentLang = languages.find(l => l.code === (i18n.language || 'hy')) || languages[0];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
    setIsOpen(false);
  };

  return (
    <div style={containerStyle}>
      <div style={selectBoxStyle} onClick={() => setIsOpen(!isOpen)}>
        <span>{currentLang.flag} {currentLang.label}</span>
        <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: '10px', opacity: 0.7 }} />
      </div>

      {isOpen && (
        <div style={dropdownStyle}>
          {languages.map((lang) => (
            <div
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              style={{
                ...optionStyle,
                background: i18n.language === lang.code ? '#f8fafc' : 'transparent',
                color: i18n.language === lang.code ? '#c5a059' : '#1e293b'
              }}
            >
              <span style={{ marginRight: '8px' }}>{lang.flag}</span>
              {lang.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// --- ՍԹԱՅԼԵՐ ---

// --- ՍԹԱՅԼԵՐ ---
const containerStyle = { 
  position: 'relative', 
  userSelect: 'none', 
  zIndex: 2000 
};

const selectBoxStyle = {
  background: '#fff', // Մաքուր սպիտակ ֆոն
  border: '2px solid #c5a059', // ✅ Ոսկեգույն հաստ եզրագիծ
  padding: '6px 12px',
  borderRadius: '10px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: ' #c5a059', 
  fontSize: '13px',
  fontWeight: '700',
  minWidth: '100px',
  transition: 'all 0.3s ease',
  boxShadow: '0 2px 10px rgba(197, 160, 89, 0.15)' // Թեթև ոսկեգույն շողք
};

const dropdownStyle = {
  position: 'absolute',
  top: '120%',
  right: 0,
  background: '#ffffff',
  borderRadius: '12px',
  boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
  overflow: 'hidden',
  width: '125px',
  border: '1px solid #c5a059', // ✅ Բացվող մենյուի եզրագիծն էլ ոսկեգույն
  zIndex: 2001
};

const optionStyle = {
  padding: '10px 15px',
  cursor: 'pointer',
  fontSize: '13px',
  display: 'flex',
  alignItems: 'center',
  transition: '0.2s',
  fontWeight: '600',
  color: ' #c5a059'
};

export default LanguageSwitcher;